module.exports = __webpack_public_path__ + "media/dashboard/assets/images/logo-8c10dc3d808d304e3654e345d67bb6e9.png";